import BaseService from './base.service';
import jwtDecode from "jwt-decode";
import VueCookies from "vue-cookies";
import CONFIG from '../environments/config';

class AuthService extends BaseService {
  async signin(user) {
    const response = await this.post('signin', user);
    if (response.data) {
      return this.getUser(response.data.data);
    }
    return null;
  }

  async getUserGuideUrl() {
    const response = await this.get('user-guide');
    return response.data.data;
  }

  getUser(token = null) {
    let decoded = null;
    if(!token) {
      token = this.getToken();
    }

    try {
      decoded = jwtDecode(token);
    } catch(e) {
      decoded = null;
      token = null;
    }
    if(token) {
      VueCookies.set(CONFIG.AUTH_STORAGE_KEY, token);
    } else {
      this.removeToken();
    }
    return decoded;
  }

  signout() {
    this.removeToken();
  }

  getToken() {
    return VueCookies.get(CONFIG.AUTH_STORAGE_KEY);
  }

  getSavedEmail() {
    return localStorage.getItem(CONFIG.AUTH_SAVE_EMAIL_KEY);
  }

  saveEmail(email) {
    localStorage.setItem(CONFIG.AUTH_SAVE_EMAIL_KEY, email);
  }

  removeEmail() {
    localStorage.removeItem(CONFIG.AUTH_SAVE_EMAIL_KEY);
  }

  removeToken() {
    VueCookies.remove(CONFIG.AUTH_STORAGE_KEY);
  }
}

export default new AuthService();